<div class="w-100 d-flex justify-content-center align-content-center h-100 commingSoon">
    <h1>
        Coming Soon!
    </h1>
</div>